"use client";

import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";

const api = apiInstance()

export const submitLeads = async (data = {}) => {
  return api.post(`/${PUBLIC_V1}/submit-leads`, data)
}
